import { ModalSwapComponent } from './../../../../../common/components/modals/modal-swap/modal-swap.component';
import { Component, computed, forwardRef, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import type { Subject } from 'rxjs';
import { DriversTachographComponent } from '../../../../../common/components/drivers-tachograph/drivers-tachograph.component';
import { ModalRealizedByComponent } from '../../../../../common/components/modal-realized-by/modal-realized-by.component';
import { ModalVehiclesComponent } from '../../../../../common/components/modals/modal-vehicles/modal-vehicles.component';
import { DelegationPeriodComponent } from '../../../common/components/delegation-period/delegation-period.component';
import { DelegationsRoute } from '../../../common/enums/delegations-route';
import { DelegationHelper } from '../../../common/helpers/delegation.helper';
import type { Delegation } from '../../../common/interfaces/delegation';
import { DelegationActionModalMode } from '../../../delegation-action-modal/delegation-action-modal.component';
import { NavigationHelper } from '../../../../../common/helpers/navigation.helper';

@Component({
  selector: 'app-delegation-modal-summary',
  imports: [
    DelegationPeriodComponent,
    ModalVehiclesComponent,
    ModalSwapComponent,
    forwardRef(() => DriversTachographComponent),
    ModalRealizedByComponent,
  ],
  templateUrl: './delegation-modal-summary.component.html',
  styleUrl: './delegation-modal-summary.component.scss',
})
export class DelegationModalSummaryComponent {
  private readonly router = inject(Router);
  private readonly delegationHelper = inject(DelegationHelper);

  public readonly delegation = input.required<Delegation>();
  public readonly close$ = input.required<Subject<void>>();

  protected isPlanned = computed(() =>
    DelegationHelper.isPlanned(this.delegation()),
  );
  protected isActive = computed(() =>
    DelegationHelper.isActive(this.delegation()),
  );
  protected driverHomeAddress = computed(
    () => this.delegation().primaryDriver.driverData.homeAddress,
  );
  protected driverAssignedBaseAddress = computed(
    () =>
      this.delegation().primaryDriver.driverData.assignedBase?.address || null,
  );

  protected edit(): void {
    this.router.navigateByUrl(
      DelegationsRoute.EDIT_DELEGATION.replace(':uuid', this.delegation().uuid),
      NavigationHelper.withOrigin(this.router),
    );
    this.close$().next();
  }

  protected openDelegationActionModal(): void {
    if (!this.delegation()) return;

    this.delegationHelper.openActionModal(
      DelegationActionModalMode.FINISH,
      this.delegation()!,
    );
  }
}
